import { ListItemText, Modal } from "@mui/material";
import React from "react";
import { useState } from "react";

import Styles from "../../Styles/Listing/ListingModal.module.css";
import { Close } from "@mui/icons-material";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomTimePicker from "../TimePicker/customTimePicker";
import TimePickerComp from "./TimePicker";

const MenuProps = {
  PaperProps: {
    style: {
      outline: "0px",
      border: "0px",
    },
  },
};

function getStyles() {
  return {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
  };
}

const ListingModal = ({ open, handleClose, type, isEdit, handleSubmit }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState();
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  const [energyReq, setEnergyReq] = useState("");
  const [energyType, setEnergyType] = useState("");
  const [energyRate, setEnergyRate] = useState("");
  const [quantity, setQuantity] = useState("");
  const [pod, setPod] = useState("");
  const [voltage, setVoltage] = useState("");

  const [deliveryType, setDeliveryType] = useState("");
  const [trader, setTrader] = useState("");

  const [expDate, setExpDate] = useState("");
  const [expTime, setExpTime] = useState("");

  
  let handleStartDate = (value) =>{}
  let handleEndDate = (value) =>{}
  let handleStartTime = (value) =>{}
  let handleEndTime = (value) =>{}

  const handleEnergyType = () => {};
  let handleEnergyrate = (value) =>{}
  let handleQuantity = (value) =>{}

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <div className={Styles.listingModalContainer}>
        <div className="modalHeading">
          <div className={Styles.listingHeading}>Add Listing</div>
          <div onClick={handleClose}>
            <Close />
          </div>
        </div>
        <div className={Styles.modalInputContainer}>
          <div className={Styles.eachLevelContainer}>
            <div>
              <div className={Styles.eachSectionHeading}>
                <span>Energy Requirement Type</span>
                <span style={{ color: "red" }}>*</span>
              </div>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <FormControlLabel
                    value="renewable"
                    control={<Radio />}
                    label={<span>Renewable</span>}
                  />
                  <FormControlLabel
                    value="non_renewable"
                    control={<Radio />}
                    label={<span>Non-Renewable</span>}
                  />
                  <FormControlLabel
                    value="any"
                    control={<Radio />}
                    label={<span>Any</span>}
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div>
              <div className={Styles.eachSectionHeading}>
                <span>Type Energy Type </span>
                <span style={{ color: "red" }}>*</span>
              </div>
              <div className={Styles.dropDownContainer}>
                <Select
                  style={{
                    height: "100%",
                    width: "100%",
                    borderRadius: "8px",
                  }}
                  displayEmpty
                  onChange={handleEnergyType}
                  input={<OutlinedInput />}
                  renderValue={(selected) => {
                    if (selected?.length === 0) {
                      return <em>Status</em>;
                    }
                    return (
                      <span
                        className={Styles.elemText}
                      >{`Add or Rspanove trader to`}</span>
                    );
                  }}
                  MenuProps={MenuProps}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem disabled value="">
                    <em>Trader List</em>
                  </MenuItem>
                  {trader?.allTraders?.map((ele) => (
                    <MenuItem key={ele?.id} value={ele?.id} style={getStyles()}>
                      <ListItemText primary={ele?.userName} />
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          <div className={Styles.eachLevelContainer}>
            <div className={Styles.dateTimeMainCont}>
              <div className={Styles.eachDateMainContainer}>
                <div className={Styles.eachSectionHeading}>
                  <span>Start Date</span>
                  <span style={{ color: "red" }}>*</span>
                </div>
                <div className={Styles.dateTimeContainer}>
                  <input type="date" name="" id="" />
                </div>
              </div>
              <div className={Styles.eachDateMainContainer}>
                <div className={Styles.eachSectionHeading}>
                  <span>End Date</span>
                  <span style={{ color: "red" }}>*</span>
                </div>
                <div className={Styles.dateTimeContainer}>
                  <input type="date" name="" id="" />
                </div>
              </div>
            </div>
            <div className={Styles.dateTimeMainCont}>
              <div>
                <div className={Styles.eachSectionHeading}>
                  <span>Start Time</span>
                  <span style={{ color: "red" }}>*</span>
                </div>
                <div>
                  <TimePickerComp
                    minutesStep="15"
                    handleSubmit={""}
                    activeTime={""}
                    maxHours="25"
                    isEdit={false}
                  />
                </div>
              </div>
              <div>
                <div className={Styles.eachSectionHeading}>
                  <span>End Time</span>
                  <span style={{ color: "red" }}>*</span>
                </div>
                <div>
                  <TimePickerComp
                    minutesStep="15"
                    handleSubmit={""}
                    activeTime={""}
                    maxHours="25"
                    isEdit={false}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={Styles.eachLevelContainer}>
            <div>
              <div className={Styles.eachSectionHeading}>
                <span>Energy Rate (₹ per Unit)</span>
                <span style={{ color: "red" }}>*</span>
              </div>
              <div className={Styles.inputTextElement}>
                <input type="text" />
              </div>
            </div>
            <div>
              <div className={Styles.eachSectionHeading}>
                <span>Quantity (MW)</span>
                <span style={{ color: "red" }}>*</span>
              </div>
              <div className={Styles.inputTextElement}>
                <input type="text" />
              </div>
            </div>
          </div>
          <div className={Styles.eachLevelContainer}>
            <div>
              <div className={Styles.eachSectionHeading}>
                <span>Point of Drawl</span>
                <span style={{ color: "red" }}>*</span>
              </div>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <FormControlLabel
                    value="renewable"
                    control={<Radio />}
                    label={<span>Renewable</span>}
                  />
                  <FormControlLabel
                    value="non_renewable"
                    control={<Radio />}
                    label={<span>Non-Renewable</span>}
                  />
                  <FormControlLabel
                    value="any"
                    control={<Radio />}
                    label={<span>Any</span>}
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div>
              <div className={Styles.eachSectionHeading}>
                <span>Voltage Level (KV) </span>
                <span style={{ color: "red" }}>*</span>
              </div>
              <div className={Styles.dropDownContainer}>
                <Select
                  style={{ height: "100%", width: "100%", borderRadius: "8px" }}
                  displayEmpty
                  onChange={handleEnergyType}
                  input={<OutlinedInput />}
                  renderValue={(selected) => {
                    if (selected?.length === 0) {
                      return <em>Status</em>;
                    }
                    return (
                      <span
                        className={Styles.elemText}
                      >{`Add or Rspanove trader to`}</span>
                    );
                  }}
                  MenuProps={MenuProps}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem disabled value="">
                    <em>Trader List</em>
                  </MenuItem>
                  {trader?.allTraders?.map((ele) => (
                    <MenuItem key={ele?.id} value={ele?.id} style={getStyles()}>
                      <ListItemText primary={ele?.userName} />
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          <div className={Styles.eachLevelContainer}>
            <div className={Styles.dateTimeMainCont}>
              <div className={Styles.eachDateMainContainer}>
                <div className={Styles.eachSectionHeading}>
                  <span>End Date</span>
                  <span style={{ color: "red" }}>*</span>
                </div>
                <div className={Styles.dateTimeContainer}>
                  <input type="date" name="" id="" />
                </div>
              </div>
              <div>
                <div className={Styles.eachSectionHeading}>
                  <span>Expiry Time</span>
                  <span style={{ color: "red" }}>*</span>
                </div>
                <div>
                  <TimePickerComp
                    minutesStep="15"
                    handleSubmit={""}
                    activeTime={""}
                    maxHours="25"
                    isEdit={false}
                  />
                </div>
              </div>
            </div>
            <div>
              <div className={Styles.eachSectionHeading}>
                <span>Voltage Level (KV) </span>
                <span style={{ color: "red" }}>*</span>
              </div>
              <div className={Styles.dropDownContainer}>
                <Select
                  style={{ height: "100%", width: "100%", borderRadius: "8px" }}
                  displayEmpty
                  onChange={handleEnergyType}
                  input={<OutlinedInput />}
                  renderValue={(selected) => {
                    if (selected?.length === 0) {
                      return <em>Status</em>;
                    }
                    return (
                      <span
                        className={Styles.elemText}
                      >{`Add or Rspanove trader to`}</span>
                    );
                  }}
                  MenuProps={MenuProps}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem disabled value="">
                    <em>Trader List</em>
                  </MenuItem>
                  {trader?.allTraders?.map((ele) => (
                    <MenuItem key={ele?.id} value={ele?.id} style={getStyles()}>
                      <ListItemText primary={ele?.userName} />
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>
          </div>
        </div>
        <div className={`modalButton ${Styles.submitContainer}`}>Submit</div>
      </div>
    </Modal>
  );
};

export default ListingModal;
